import { datadogRum } from '@datadog/browser-rum';
import React, { PureComponent, ErrorInfo } from 'react';
import styled from 'styled-components';
import { BlueButton } from '../buttons';
import { Title } from '../titles';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 4rem 0 2rem;

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    padding-top: 3rem;
  }
`;

const BlueRetryButton = styled(BlueButton)`
  width: 20rem;
`;

const ErrorDetails = styled.details`
  white-space: pre-wrap;
`;

const Content = styled.div`
  text-align: center;
  max-width: 32rem;
  padding-right: 2rem;
  padding-left: 2rem;
  color: #6d7184;
  font-weight: 390;
`;

const Text = styled.div`
  padding: 1rem 0 5rem;
  font-size: 1rem;
`;

const ChatContainer = styled.span`
  color: #228be6;
  cursor: pointer;
  text-decoration: underline;
`;

interface ErrorProps {
  error: string | null;
  errorInfo: ErrorInfo;
  message: string | null;
  unableToGetTerms: boolean;
}

class FinanceError extends PureComponent<ErrorProps> {
  static defaultProps = {
    error: null,
    errorInfo: {},
    message: null,
    unableToGetTerms: false
  };

  state = {
    isLoading: false
  };

  componentDidMount() {
    const { error, errorInfo = {}, message } = this.props;
    const errorToReport =
      error === null ? message || 'Unable to determine error message' : error;
    datadogRum.addError(errorToReport, {
      errorInfo,
      message,
      customType: 'oopsieDaisy'
    });
  }

  routeToNext = async () => {
    this.setState({ isLoading: true });
    window.location.href = '/acquisition/dashboard';
    return null;
  };

  routeToPaymentType = async () => {
    this.setState({ isLoading: true });
    window.location.href = '/purchase/payment-options/type';
    return null;
  };

  render() {
    const { error, errorInfo, message, unableToGetTerms } = this.props;
    const { isLoading } = this.state;
    return (
      <Wrapper>
        <Title>Unable to get your terms</Title>

        {process.env.NODE_ENV !== 'production' && error && (
          <ErrorDetails open>
            {error && error.toString()}

            <br />
            {errorInfo.componentStack}
          </ErrorDetails>
        )}

        <Content>
          <Text>
            {message ? message : "We're sorry, something went wrong. "}
            You can{' '}
            <ChatContainer onClick={() => CarvanaChatUi.show()}>
              chat
            </ChatContainer>{' '}
            with us or call 1-888-415-0894 to learn more about your options.
          </Text>

          <BlueRetryButton
            data-cv-test="backButton"
            onClick={
              // eslint-disable-next-line no-nested-ternary
              unableToGetTerms ? this.routeToPaymentType : this.routeToNext
            }
            isBusy={isLoading}
            disabled={isLoading}
          >
            Choose Payment Type
          </BlueRetryButton>
        </Content>
      </Wrapper>
    );
  }
}

export default FinanceError;
